import { DataWidgetBase } from '../models';
import { ReadType } from '../../models/enum';
import { guidEmpty, Helper } from '../../common';

import { PivotTableWidgetDefinition as definition } from './pivotTable.definition';
import { PivotTableConfiguration } from './pivotTable.configuration';
import { WidgetValuesReadConfiguration } from '../../models';
import { IwidgetIntervalHelperService } from '../../services/helpers';
import { IBindable } from '../../models/IBindable';
import { IGetReadConfiguration } from '../models/IGetReadConfiguration';

export class PivotTableWidget extends DataWidgetBase implements IGetReadConfiguration {
  baseType = definition.baseType;
  col = 0;
  configuration: PivotTableConfiguration;
  exportFormats = ['csv'];
  guid: string;
  hasExtendedProperties = true;
  highlights = definition.highlights;
  icon = definition.icon;
  isExportable = true;
  name = definition.title;
  row = 0;
  sizeX = 6;
  sizeY = 18;
  type = definition.type;

  constructor(intervalHelper: IwidgetIntervalHelperService) {
    super(intervalHelper);
    this.guid = Helper.getGuid();
    this.configuration = new PivotTableConfiguration();
  }

  getReadConfiguration(
    beginDate: string,
    endDate: string
  ): WidgetValuesReadConfiguration {
    const series: IBindable[] = this.configuration.series.map((d) => d);
    const hasRowSeries =
      this.configuration.rowSeries &&
      !!this.configuration.rowSeries.guid &&
      this.configuration.rowSeries.guid !== guidEmpty;
    if (hasRowSeries) {
      series.push(this.configuration.rowSeries);
    }
    const result = this.getReadConfigurationBase(
      beginDate,
      endDate,
      series,
      this.configuration,
      null,
      false,
      false,
      false,
      false,
      true,
      ReadType.AllValues,
      !!this.configuration.series.filter((s) => s.hasAlarms).length
    );
    if (hasRowSeries) {
      result.aggregationReadConfiguration = {
        guid: this.configuration.rowSeries.guid,
        value: this.configuration.rowSeries.value,
        series: this.configuration.series,
        min: this.configuration.rowSeries.min,
        max: this.configuration.rowSeries.max,
        bins: this.configuration.rowSeries.bin,
        decimals: this.configuration.rowSeries.decimals,
      };
    }
    return result;
  }
  // Type any could be imprved here, but require further analysis than an issue fix allows for
  getSeries(): any[] {
    return (this.configuration.series as any[]).concat([
      this.configuration.rowSeries,
    ]);
  }
  
  setSeries(series: any[]) {
    // #52784 : hack to prevent setting row series when cloning
    this.configuration.series = series.filter((d) => !!d.aggregationMode);
  }
}